import React from 'react';
import PersonalTodosPanel from '../../../components/portal/PersonalTodosPanel';

export default function AdminTodos() {
  return (
    <div className="p-7 space-y-6 bg-[#F8FAFC]">
      <div>
        <p className="label-meta mb-1">Personal</p>
        <h1 className="heading-md text-[#1F2937]">My TODOs</h1>
        <p className="text-[#6B7280] text-sm mt-1">Private task list — only visible to you.</p>
      </div>
      <PersonalTodosPanel />
    </div>
  );
}
